import { AllTransacoesDto } from '../../../../global/dataTransferObjects/transacoesTempoReal';
import {IPhobeusPagedResult, IPhobeusPagedResultNew} from '../../../../global/generics';

export interface IPageState {
  loading: boolean;
  zeroState: boolean;
  blob?: any | null;
  allLiveTransactions: IPhobeusPagedResultNew<AllTransacoesDto>;
}

export enum ActionTypes {
  UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS',
  GET_ALL_LIVE_TRANSACTIONS = 'GET_ALL_LIVE_TRANSACTIONS',
  SHOW_ZERO_STATE = 'SHOW_ZERO_STATE',
  GET_FILE_DOWNLOAD = 'GET_FILE_DOWNLOAD',
}

export interface IAction {
  type: ActionTypes;
  payload?: any;
}
